/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */
import { FancyFirebaseReferencer } from './FancyFirebaseReferencer';
import { logger } from '@touchplan/logging';
import { IFancyConfig } from '../FancyConfig';
import { FancyDatabase, IRefLike } from '@touchplan/common';

export class MasterFancyFirebaseReferencer<DbRef extends IRefLike> extends FancyFirebaseReferencer<DbRef> {
	private _specialMasterRefUrl: string = '';
	/**
	 * This is a class created to specifically tackle getting reference if the fancyFirebaseReferencer is not yet initialized. Use this in only this case.
	 * @param path A rootless path to the data trying to be read ('projects', not 'Root/projects')
	 */
	public getLegacyRef<SdkRef extends DbRef>(path: string): SdkRef {
		const pathSegments = this.cleanPathSegmentArray(path);
		const rootIncludedPath = this.makeFinalPath(pathSegments);
		return this.fancyDb.toFirebaseRef(this.fancyDb.getRef(rootIncludedPath, undefined)) as SdkRef;
	}

	//an enhancement here would be to refactor the fancyFirebaseReferencer to inject fancyState instead of importing it. Then we could solve
	// this init problem with dependency injection
	public init(): void {
		logger.error('Use masterInit for the special master referencer');
	}

	public masterInit(config: IFancyConfig, fancyDatabase: FancyDatabase<DbRef>): void {
		this._specialMasterRefUrl = config.firebaseRefUrl;
		this.fancyDb = fancyDatabase;
		this._initialized = true;
	}

	protected getRefUrl(): string {
		return this._specialMasterRefUrl;
	}
}
// BEGIN PLACEHOLDER REPLACE AS PART OF TP-6697
//TODO - this will be the wrong type and it's probably not fixable while ref's are still part of this file
// - equivalent comment on normal FancyFirebaseReferencer
// - refLike might be ok for the master one... or maybe migrate master to immediately use
// the fancyRef
export const masterFancyFirebaseReferencer: MasterFancyFirebaseReferencer<IRefLike> =
	new MasterFancyFirebaseReferencer();
// END PLACEHOLDER REPLACE AS PART OF TP-6697
